var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-end items-end fixed cursor-pointer position-fixed right-10 bottom-10",staticStyle:{"right":"10px","bottom":"10px"}},[_c('div',{staticClass:"w-60px h-60px addButton",on:{"click":_vm.onClick}},[_c('i',{staticClass:"bx bx-plus bx-md"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }